import request from '@/utils/request'
import axios from 'axios'
import { getToken, getBbsToken, setBbsToken, removeBbsToken } from '@/utils/auth'
import qs from 'qs'

// login 登陆
export function login (data) {
  return request({
    url: '/api/v2/login',
    method: 'post',
    data
  })
}

// logout 退出
export async function logout () {
  const mainToken = getToken()
  const bbsToken = getBbsToken()
  await Promise.all([
    axios.post('/api/v2/logout', {}, {
      timeout: 10000,
      headers: mainToken ? { Authorization: 'Bearer ' + mainToken } : {},
    }).catch(() => null),
    axios.get('/bbs-api/login/signout', {
      timeout: 10000,
      headers: bbsToken ? { 'X-User-Token': bbsToken } : {},
    }).catch(() => null),
  ])
}

export async function syncBbsSession (token) {
  const previousToken = getBbsToken()
  removeBbsToken()
  try {
    const response = await axios.post('/bbs-api/login/main/session', {}, {
      timeout: 10000,
      headers: {
        Authorization: 'Bearer ' + token,
        ...(previousToken ? { 'X-User-Token': previousToken } : {}),
      },
    })
    const result = response.data
    if (result && result.success && result.data && result.data.token) {
      setBbsToken(result.data.token)
    }
  } catch (error) {
    // The BBS retries the exchange on entry if it is temporarily unavailable.
  }
}

// refreshtoken 刷新token
export function refreshtoken (data) {
  return request({
    url: '/refreshtoken',
    method: 'post',
    data
  })
}

// getInfo 获取用户基本信息
export function getInfo () {
  return request({
    url: '/api/v1/getinfo',
    method: 'get'
  })
}

// 查询用户个人信息
export function getUserProfile () {
  return request({
    url: '/api/v2/user/profile',
    method: 'get'
  })
}

// 获取当前登录用户，用于恢复旧版本写坏的用户名 Cookie
export function getCurrentUser () {
  return request({
    url: '/api/v2/user/user-current',
    method: 'get'
  })
}

// 手机验证码登录
export function phoneLogin (data) {
  return request({
    url: '/api/v2/t-user/sms/login',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 邮箱验证码登录
export function emailLogin (data) {
  return request({
    url: '/api/v2/t-user/email/login',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取在线设备列表
export function getOnlineDevices () {
  return request({
    url: '/api/v2/user/online-devices',
    method: 'get'
  })
}

// 踢出设备
export function kickDevice (sessionId) {
  return request({
    url: '/api/v2/user/kick-device',
    method: 'post',
    data: {
      sessionId
    }
  })
}

// 获取登录通知
export function getLoginNotify () {
  return request({
    url: '/api/v2/user/login-notify',
    method: 'get',
    notAuth: true,
  })
}

// WeChat PC QR login
export function createWechatTicket (data) {
  return request({ url: '/api/v2/wechat/ticket', method: 'post', data })
}

export function getWechatTicketStatus (ticketId, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}`, method: 'get', headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function exchangeWechatTicket (ticketId, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/exchange`, method: 'post', headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function cancelWechatTicket (ticketId, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/cancel`, method: 'post', headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function sendWechatPhoneChallenge (ticketId, phone, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/phone/challenge`, method: 'post', data: { phone }, headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function bindWechatPhone (ticketId, data, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/phone`, method: 'post', data, headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function sendWechatEmailChallenge (ticketId, email, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/email/challenge`, method: 'post', data: { email }, headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}

export function bindWechatEmail (ticketId, data, pollToken) {
  return request({ url: `/api/v2/wechat/ticket/${ticketId}/email`, method: 'post', data, headers: { 'X-Wechat-Poll-Token': pollToken }, notAuth: true })
}
